import { Content, Placeholder } from '@kinesis/bungle';

// Renders when `/page/<key>` returns the `not-found` arm — i.e. the URL
// names a page that doesn't exist on this disclosure shape. A legitimate
// 200 response (not an HTTP 404), so the page can render the empty state
// without distinguishing transport-level errors.
const DisclosureNotFound = () => (
  <Content
    alignX='center'
    textAlign='center'
    padding='medium'
    paddingMode='equal'
  >
    <Placeholder>Page not found.</Placeholder>
  </Content>
);

export { DisclosureNotFound };
